<template>
  <div class="wrapper">
    <div class="cover-wrapper">
      <div class="check-letter" @click="checkLetter()">
        <img class="check-img" style="width: 100%" src="../../assets/images/activity/thanksLetter/cover-check.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    checkLetter () {
      this.$router.replace({ 'path': '/activity/thanks-letter-2020' })
    }
  }
}
</script>
<style lang='less'>
.wrapper {
  background-color: #1a4146;
  width: 100%;
  height: 100%;
}
.cover-wrapper {
  position: relative;
  width: 375px;
  height: 667px;
  background-image: url('../../assets/images/activity/thanksLetter/cover-bg.png');
  background-size: 100% 100%;
  .check-letter {
    position: absolute;
    width: 76px;
    height: 76px;
    bottom: 25%;
    left: 50%;
    transform: translateX(-50%);
  }
}
.check-img {
  animation: checkmove 4s infinite ease-in-out;
}
@keyframes checkmove
{
  0%{
  transform: scale(1);
  }
  25%{
      transform: scale(1.1);
  }
  50%{
      transform: scale(1);
  }
  75%{
      transform: scale(1.1);
  }
}
</style>
